const getModal = () => window.bootstrap?.Modal;

const closeModal = (modalId) => {
  const Modal = getModal();
  const el = document.getElementById(modalId);
  if (Modal && el) {
    const instance = Modal.getInstance(el);
    if (instance) {
      instance.hide();
    }
  }
};

const closeBackdrop = () => {
  let elements = document.getElementsByClassName('modal-backdrop');
  while (elements.length > 0) {
    elements[0].remove();
  }
};

const openModal = (modalID) => {
  const Modal = getModal();
  const el = document.getElementById(modalID);
  if (Modal && el) {
    const instance = Modal.getInstance(el) || new Modal(el);
    instance.show();
  }
};

export { closeBackdrop, closeModal, openModal };
